
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import vueCanvasPoster from 'vue-canvas-poster';
import { Popup, Button } from 'vant';
import QRCode from 'qrcode';
// import * as config from '../config';

Vue.use(Popup).use(Button).use(vueCanvasPoster);
@Component({
  name: 'Canvas',
  components: {
    // vueCanvasPoster,
  },
})
export default class Canvas extends Vue {
  @Prop() id: any;
  @Prop() textIndex: any;
  imgList: any = [
    { url: require('../assets/01-南天湖.jpg'), text: '南天湖' },
    { url: require('../assets/02-马拉松.jpg'), text: '马拉松' },
    { url: require('../assets/03-金佛山.jpg'), text: '金佛山' },
    { url: require('../assets/04-瞿塘峡.jpg'), text: '瞿塘峡' },
    { url: require('../assets/05-涪江.jpg'), text: '涪江' },
    { url: require('../assets/06-红池坝.jpg'), text: '红池坝' },
    { url: require('../assets/07-融创茂.jpg'), text: '融创茂' },
    { url: require('../assets/08-阿依河.jpg'), text: '阿依河' },
    { url: require('../assets/09-峨眉山.jpg'), text: '峨眉山' },
    { url: require('../assets/10-九寨沟.jpg'), text: '九寨沟' },
  ];
  swipe: any = [
    {
      text: '欢乐贺新春，运动迎冬奥。努力创建国家体育旅游示范区，打造全国户外运动目的地。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '继续保持奋斗姿态，努力为建设体育强市作出新贡献。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '坚定信心、团结拼搏，埋头苦干、勇毅前行，奋力推动体育强市建设迈上新台阶！祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '不要人夸颜色好，只留清气满乾坤。祝虎年大吉、万事如意，幸福安康！',
    },

    { text: '畅游巴山蜀水，乐享运动川渝。祝虎年大吉、万事如意，幸福安康！' },
    {
      text: '“川”越巴山蜀水，运动“渝”您同行。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '巴山蜀水如诗画，川渝体旅邀天下。祝虎年大吉、万事如意，幸福安康！！',
    },
    {
      text: '巴山蜀水好风光，体育旅游最时尚。祝虎年大吉、万事如意，幸福安康！',
    },
    {
      text: '巴山蜀水总是情，体育旅游川渝行。祝虎年大吉、万事如意，幸福安康！',
    },
  ];
  detailData: any = {};
  GradeData: any;
  explain = '';
  content = '';
  showCanvas = false;
  src = '';
  painting = {};
  name: any = '';
  @Watch('id')
  changId() {
    this.getPainting();
  }
  @Watch('textIndex')
  changTextIndex() {
    this.getPainting();
  }
  mounted() {
    this.name = window.localStorage.getItem('nickname')
      ? '——' + window.localStorage.getItem('nickname')
      : '';
    this.getPainting();
  }
  getPainting() {
    // 开始绘制
    const id = window.sessionStorage.getItem('XMHKid');

    this.painting = {
      width: '600px',
      height: '1074px',
      views: [
        {
          type: 'image',
          id: 'cover',
          url: `${this.imgList[this.id].url}`,
          css: {
            width: '600px',
            height: '1066px',
            mode: 'scaleToFill',
          },
        },
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/主题.png'),
          css: {
            top: '150px',
            left: '120px',
            width: '360px',
            mode: 'scaleToFill',
          },
        },
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/背景框.png'),
          css: {
            top: '380px',
            left: '80px',
            width: '480px',
            mode: 'scaleToFill',
          },
        },
        {
          type: 'text',
          id: 'swipe',
          text: `${this.swipe[this.textIndex].text}`,
          css: {
            top: '420px',
            left: '125px',
            color: '#ce443f',
            width: '400px',
            fontSize: '26px',
            lineHeight: '32px',
          },
        },
        {
          type: 'text',
          id: 'name',
          text: `${this.name}`,
          css: {
            top: '535px',
            color: '#ce443f',
            width: '360px',
            left: '150px',
            fontSize: '26px',
            lineHeight: '32px',
            fontWeight: 'bold',
            textAlign: 'right',
          },
        },
        // {
        //   type: 'text',
        //   text: '长按保存海报',
        //   css: {
        //     bottom: '50px',
        //     left: '200px',
        //     color: '#fff',
        //     fontSize: '30px',
        //   },
        // },
        {
          type: 'text',
          text: '长按保存海报长按保存海报长',
          css: {
            width: '110px',
            height: '110px',
            background: '#fff',
            bottom: '35px',
            right: '35px',
            color: '#fff',
            fontSize: '27.5px',
          },
        },
        {
          type: 'image',
          id: 'cover',
          url: require('../assets/qrCode.png'),
          css: {
            bottom: '40px',
            right: '40px',
            width: '100px',
            mode: 'scaleToFill',
          },
        },
      ],
    };
  }

  success(src: any) {
    // 设置img的src
    this.src = src;
  }
  fail(err: any) {
    console.log('fail', err);
  }
}
